import React from "react";
import { NavLink } from "react-router-dom";

import {
  Flex,
  FlexItem,
  Title,
  Button
} from "@patternfly/react-core";

import useNavigation from "../../hooks/useNavigation";

import "./MegaMenuHeader.css";

const MegaMenuHeader = ({ menu }) => {
  const { closeMegaMenu } = useNavigation();

  return (
    <div className="school-mega-menu-header">
      <Flex
        justifyContent={{ default: "justifyContentSpaceBetween" }}
        alignItems={{ default: "alignItemsCenter" }}
      >
        <FlexItem>
          <Title headingLevel="h2">
            {menu.title}
          </Title>
        </FlexItem>

        {menu.viewAll && (
          <FlexItem>
            <Button
              component={NavLink}
              to={menu.viewAll.to}
              variant="link"
              isInline
              onClick={closeMegaMenu}
            >
              {menu.viewAll.label}
            </Button>
          </FlexItem>
        )}
      </Flex>
    </div>
  );
};

export default MegaMenuHeader;